const tokenStore = {
    setToken(token) {
        localStorage.setItem('user-token', token);
    },
    getToken() {
        return localStorage.getItem('user-token');
    },
    clearToken() {
        localStorage.removeItem('user-token');
    }
};

export default tokenStore;